import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-accent to-primary overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20" />
      
      <div className="container mx-auto px-4 py-12 md:py-16 lg:py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 md:mb-8" data-aos="fade-down" data-aos-delay="150">
            <Icon name="MessageCircle" size={40} color="white" strokeWidth={2} className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12" />
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 md:mb-6"data-aos="fade-up" data-aos-delay="150">
            Hubungi Kami
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto mb-6 md:mb-8" data-aos="fade-up" data-aos-delay="150">
            Tim Honda Pamulang siap membantu Anda. Hubungi kami melalui berbagai saluran komunikasi yang tersedia untuk konsultasi, informasi produk, atau layanan purna jual.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
            <a
              href="https://wa.me/+6288293642972"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 md:px-8 py-3 md:py-4 bg-white text-primary rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-300 shadow-lg hover:shadow-xl"
              data-aos="fade-right" data-aos-delay="150"
            >
              <Icon name="MessageCircle" size={20} />
              <span>Chat WhatsApp</span>
            </a>

            <a
              href="tel:+6288293642972"
              className="inline-flex items-center space-x-2 px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/20 transition-all duration-300 border border-white/30"
              data-aos="fade-left" data-aos-delay="150"
            >
              <Icon name="Phone" size={20} />
              <span>Telepon Kami</span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};

export default ContactHero;